import { createFileRoute } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { getConfigQuery } from '@/features/administrator-panel/configuration/api/configApi';

export const Route = createFileRoute('/admin/configuration')({
  loader: () => crownQueryClient.ensureQueryData(getConfigQuery),
  head: () => ({ meta: [{ title: 'Settings' }] }),
});
